/**
 * free-gift-countdown.js
 *
 * Countdown widget for promo banners.
 * Binds to any [data-free-gift-countdown][data-end-iso="<ISO-8601>"] element.
 *
 * Rendering modes (auto-detected per element):
 *   - Multi-slot: if the element contains children with [data-cd-days], [data-cd-hours],
 *     [data-cd-minutes], [data-cd-seconds] — fills each slot individually (DAYS/HRS/MIN/SEC layout).
 *   - Single: falls back to setting textContent on the container as HH:MM:SS.
 *
 * Independent from assets/count-down-timer.js (cart reservation timers).
 */
(function () {
  'use strict';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function formatSingle(remainingMs) {
    if (remainingMs <= 0) return '00:00:00';
    var totalSec = Math.floor(remainingMs / 1000);
    var hours = Math.floor(totalSec / 3600);
    var minutes = Math.floor((totalSec % 3600) / 60);
    var seconds = totalSec % 60;
    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function breakdown(remainingMs) {
    if (remainingMs <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    var totalSec = Math.floor(remainingMs / 1000);
    var days = Math.floor(totalSec / 86400);
    var hours = Math.floor((totalSec % 86400) / 3600);
    var minutes = Math.floor((totalSec % 3600) / 60);
    var seconds = totalSec % 60;
    return { days: days, hours: hours, minutes: minutes, seconds: seconds };
  }

  function startCountdown(el) {
    var endIso = el.getAttribute('data-end-iso');
    if (!endIso) { renderFallback(el, 'Ends soon'); return; }
    var endMs = Date.parse(endIso);
    if (isNaN(endMs)) { renderFallback(el, 'Ends soon'); return; }

    var slots = {
      days: el.querySelector('[data-cd-days]'),
      hours: el.querySelector('[data-cd-hours]'),
      minutes: el.querySelector('[data-cd-minutes]'),
      seconds: el.querySelector('[data-cd-seconds]')
    };
    var hasSlots = slots.days || slots.hours || slots.minutes || slots.seconds;

    function tick() {
      var remaining = endMs - Date.now();
      if (remaining <= 0) {
        if (hasSlots) {
          if (slots.days) slots.days.textContent = '00';
          if (slots.hours) slots.hours.textContent = '00';
          if (slots.minutes) slots.minutes.textContent = '00';
          if (slots.seconds) slots.seconds.textContent = '00';
        } else {
          el.textContent = '00:00:00';
        }
        el.setAttribute('data-expired', 'true');
        clearInterval(intervalId);
        return;
      }
      if (hasSlots) {
        var b = breakdown(remaining);
        if (slots.days) slots.days.textContent = pad(b.days);
        if (slots.hours) slots.hours.textContent = pad(b.hours);
        if (slots.minutes) slots.minutes.textContent = pad(b.minutes);
        if (slots.seconds) slots.seconds.textContent = pad(b.seconds);
      } else {
        el.textContent = formatSingle(remaining);
      }
    }

    tick();
    var intervalId = setInterval(tick, 1000);
    el.__freeGiftCountdownInterval = intervalId;
  }

  function renderFallback(el, msg) {
    var slots = el.querySelectorAll('[data-cd-days], [data-cd-hours], [data-cd-minutes], [data-cd-seconds]');
    if (slots.length) {
      Array.prototype.forEach.call(slots, function (s) { s.textContent = '--'; });
    } else {
      el.textContent = msg;
    }
  }

  function boot() {
    var els = document.querySelectorAll('[data-free-gift-countdown]');
    Array.prototype.forEach.call(els, function (el) {
      if (el.__freeGiftCountdownBound) return;
      el.__freeGiftCountdownBound = true;
      startCountdown(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var observer = new MutationObserver(function () { boot(); });
  observer.observe(document.body, { childList: true, subtree: true });
})();
